import { Navigate } from "react-router-dom";
import AuthLoadingScreen from "./AuthLoadingScreen";
import RequireAuth from "./RequireAuth";
import { useAuth } from "./useAuth";
import { isSuperAdminUser } from "./superAdmin";

const RequirePermission = ({
  permission,
  permissions = [],
  mode = "any",
  children,
}) => {
  const codes = permission ? [permission] : permissions;
  const { isLoading, user, hasAnyPermission, hasAllPermissions } = useAuth();

  const allowed = isSuperAdminUser(user)
    ? true
    : mode === "all"
      ? hasAllPermissions(codes)
      : hasAnyPermission(codes);

  return (
    <RequireAuth>
      {isLoading ? (
        <AuthLoadingScreen />
      ) : allowed ? (
        children
      ) : (
        <Navigate to="/unauthorized" replace />
      )}
    </RequireAuth>
  );
};

export default RequirePermission;
